import { render, staticRenderFns } from "./save_button_ajil_zar.vue?vue&type=template&id=d846cc4e&"
import script from "./save_button_ajil_zar.vue?vue&type=script&lang=js&"
export * from "./save_button_ajil_zar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports